import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const exportToPdf = async (containerRef: React.RefObject<HTMLElement>): Promise<void> => {
    // exportToPdf0(containerRef);

    const container = containerRef.current;
    if (container) {
        await convertAllSVGImagesToBase64(container);
       
        await html2canvas(container, { scale: 2 }); //precache svg images
        const canvas = await html2canvas(container, { scale: 2 });
        const imageData = canvas.toDataURL("image/jpeg", 1.0);

        // Initialize jsPDF
        const pdf = new jsPDF("p", "pt", "a4");

        // Calculate the dimensions to fit the A4 page
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        // Add the image to the PDF
        pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight, undefined, "SLOW");

        // Save the PDF
        pdf.save("sessionReport.pdf");
    }
};

const convertAllSVGImagesToBase64 = async (container: HTMLElement): Promise<void> => {
    const svgs = container.querySelectorAll<SVGSVGElement>("svg");

    for (const svg of svgs) {
        // Convert all nested images within each SVG
        const images = svg.querySelectorAll<SVGImageElement>("image");
        
        for (const img of images) {
            const href = img.getAttribute("href");
            if (href) {
                // Ensure the image has fully loaded before converting to base64
                await new Promise<void>((resolve, reject) => {
                    const imageLoader = new Image();
                    imageLoader.src = href;
                    imageLoader.onload = async () => {
                        // Fetch the image and convert it to base64
                        try {
                            const response = await fetch(href);
                            const blob = await response.blob();
                            const reader = new FileReader();

                            reader.onloadend = () => {
                                img.setAttribute("href", reader.result as string);
                                resolve();
                            };
                            reader.readAsDataURL(blob);
                        } catch (error) {
                            console.error("Error converting SVG image to base64:", error);
                            reject(error);
                        }
                    };
                    imageLoader.onerror = (error) => {
                        console.error("Error loading SVG image:", error);
                        reject(error);
                    };
                });
            }
        }
    }
};
